import styled from 'styled-components';

import Text from 'components/_core/Text';

export const ClickHereLink = styled(Text).attrs({
  color: 'ctaBlue.-1',
  fontWeight: 'weight-500',
  size: 'sm',
  variant: 'primary',
})`
  &:hover {
    color: ${({ theme }) => theme.colors.ctaBlue(0)};
  }
`;
